<template>
  <div class="pdt-20px steps-container">
    <ul class="steps has-content-centered"
        :class="{'is-vertical': isVertical, 'width-67': !isVertical}">
      <li v-for="(step, index) in steps"
          :key="index"
          class="steps-segment"
          :class="{'is-active': actualStep === index}">
        <div class="steps-marker" v-if="index >= actualStep"> {{ step.step }}</div>
        <div class="steps-marker" v-else>
          <b-icon icon="check">
          </b-icon>
        </div>
        <div class="steps-content is-paddingless">
          <p class="is-size-7 pdl-15px" :class="isPrimaryOrDefault(index)">
            {{ step.title }}
          </p>
          <p class="has-text-weight-bold is-size-6 pdl-15px" :class="isLinkOrDefault(index)">
            {{ step.sousTitle }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'GeneralSteps',
  props: {
    actualStep: Number,
    steps: Array,
    isVertical: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    isLinkOrDefault(index) {
      if (index >= this.actualStep) return 'has-text-link';
      return 'has-text-default';
    },
    isPrimaryOrDefault(index) {
      if (index >= this.actualStep) return 'has-text-primary';
      return 'has-text-default';
    },
  },
};
</script>

<style scoped>

</style>
